<template>
	<div>
		<el-container>
			<el-aside width="250px">
				<LocationTree @getTreeData="locationTreeNodeClick"/>
			</el-aside>

			<el-container>
				<el-header style="margin-bottom: 15px; height: auto;">
					<el-form :inline="true" style="margin-bottom: 15px;">

						<el-form-item>
							<el-input
							  v-model="searchForm.machineName"
							  placeholder="设备名称"
							  clearable
							>
							</el-input>
						</el-form-item>

						<el-form-item>
							<el-select v-model="searchForm.isOnline" placeholder="在线/离线">
								<el-option
								  v-for="item in [
									{
										label: '全部',
										value: 0
									},
									{
										label: '在线',
										value: 1
									},
									{
										label: '离线',
										value: 2
									}
								  ]"
								  :key="item.value"
								  :label="item.label"
								  :value="item.value">
								</el-option>
							</el-select>
						</el-form-item>

						<el-form-item>
							<el-select v-model="searchForm.isOpen" placeholder="开门/关门">
								<el-option
								  v-for="item in [
										{
											label: '全部',
											value: 0
										},
										{
											label: '开门',
											value: 1
										},
										{
											label: '关门',
											value: 2
										}
								  ]"
								  :key="item.value"
								  :label="item.label"
								  :value="item.value">
								</el-option>
							</el-select>
						</el-form-item>

						<el-form-item>
							<el-button @click="getLocationMachineList">搜索</el-button>
						</el-form-item>

						<el-form-item>
							<el-button type="primary" @click="addHandle">新增</el-button>
						</el-form-item>
						<el-form-item>
							<el-popconfirm title="确定批量删除位置设备吗？" @confirm="delHandle(null)">
								<el-button type="danger" slot="reference" :disabled="delBtlStatu">批量删除</el-button>
							</el-popconfirm>
						</el-form-item>
					</el-form>

					<el-switch
					  v-model="listIconToggleValue"
					  active-text="列表"
					  inactive-text="图标">
					</el-switch>
				</el-header>

				<div id="chart" style="width: 100%; height: 250px;"></div>

				<template v-if="listIconToggleValue">
					<el-main style="flex: none;">
						<el-table
						  v-loading='loading'
						  ref="multipleTable"
						  :data="tableData"
						  tooltip-effect="dark"
						  style="margin-top: -20px;"
						  :height="tableHeight"
						  :row-style="{height: '0px'}"
						  :cell-style="{padding: '2px'}"
						  :header-cell-style="{background: '#E6F2FE', height:'8px',padding:'8px'}"
						  border
						  stripe
						  @selection-change="handleSelectionChange">

							<el-table-column
							  type="selection"
							>
							</el-table-column>

							<el-table-column
							  prop="locationFullName"
							  label="安装位置"
							  show-overflow-tooltip>
							</el-table-column>

							<el-table-column
							  prop="machineShortName"
							  label="设备名称"
							  show-overflow-tooltip>
							</el-table-column>

							<el-table-column
							  prop="shortName"
							  label="位置别名"
							  show-overflow-tooltip>
							</el-table-column>

							<el-table-column
							  label="当前温度（℃）"
							  align="center"
							  show-overflow-tooltip>
								<template slot-scope="scope">
									{{ scope.row.temperature / 10 }}
								</template>
							</el-table-column>

							<el-table-column
							  label="当前湿度（%）"
							  align="center"
							  show-overflow-tooltip>
								<template slot-scope="scope">
									{{ scope.row.humidity / 10 }}
								</template>
							</el-table-column>

							<el-table-column
							  label="设备状态"
							  align="center"
							  show-overflow-tooltip
							>
								<template slot-scope="scope">
									<el-tag
									  :type="scope.row.isOnline ? 'success' : 'danger'"
									  disable-transitions>{{ scope.row.isOnline ? '在线' : '离线' }}
									</el-tag>
								</template>
							</el-table-column>

							<el-table-column
							  label="柜门状态"
							  align="center"
							  show-overflow-tooltip
							>
								<template slot-scope="scope">
									<el-tag
									  :type="scope.row.iostatus ? 'danger' : 'success'"
									  disable-transitions>{{ scope.row.iostatus ? '开' : '关' }}
									</el-tag>
								</template>
							</el-table-column>

							<el-table-column
							  prop="icon"
							  label="操作"
							>

								<template slot-scope="scope">

									<el-button type="text" @click="humitureRecord(scope.row.machineId)">温湿度
									</el-button>

									<el-divider direction="vertical"></el-divider>

									<el-button type="text" @click="doorRecord(scope.row.machineId)">开门记录</el-button>

									<el-divider direction="vertical"></el-divider>

									<el-button type="text" @click="editHandle(scope.row.id)">编辑</el-button>

									<el-divider direction="vertical"></el-divider>

									<template>
										<el-popconfirm title="确定远程开门吗？"
													   @confirm="openHandle(scope.row.machineId)">
											<el-button type="text" slot="reference">开门</el-button>
										</el-popconfirm>
									</template>

								</template>
							</el-table-column>

						</el-table>
					</el-main>
				</template>

				<template v-else>
					<el-main>
						<div class="icon-container">
							<template v-for="item in tableData">
								<el-card class="icon-content">
									<i class="el-icon-menu"></i>
									<el-form ref="form" label-width="100px">
										<el-form-item label="位置名称：">
											{{ item.locationFullName }}
										</el-form-item>
										<el-form-item label="设备名称：">
											{{ item.machineShortName }}
										</el-form-item>
										<el-form-item label="当前温度：">
											{{ item.temperature / 10 }}℃
										</el-form-item>
										<el-form-item label="当前湿度：">
											{{ item.humidity / 10 }}%
										</el-form-item>
										<el-form-item label="设备状态：">
											<el-tooltip v-if="item.isOnline" class="item" effect="light" content="在线"
														placement="right">
												<p class="icon-success"></p>
											</el-tooltip>
											<el-tooltip v-else class="item" effect="light" content="离线"
														placement="right">
												<p class="icon-error"></p>
											</el-tooltip>
										</el-form-item>
										<el-form-item label="柜门状态：">
											<el-tooltip v-if="item.iostatus" class="item" effect="light" content="关闭"
														placement="right">
												<p class="icon-success"></p>
											</el-tooltip>
											<el-tooltip v-else class="item" effect="light" content="开启"
														placement="right">
												<p class="icon-error"></p>
											</el-tooltip>
										</el-form-item>
									</el-form>

									<el-button type="text" @click="humitureRecord(item.machineId)">温湿度</el-button>

									<el-divider direction="vertical"></el-divider>

									<el-button type="text" @click="doorRecord(item.machineId)">开门记录</el-button>

									<el-divider direction="vertical"></el-divider>

									<template>
										<el-popconfirm title="确定远程开门吗？"
													   @confirm="openHandle(item.machineId)">
											<el-button type="text" slot="reference">开门</el-button>
										</el-popconfirm>
									</template>
								</el-card>
							</template>
						</div>
					</el-main>
				</template>


				<el-pagination
				  style="text-align: right;"
				  @size-change="handleSizeChange"
				  @current-change="handleCurrentChange"
				  layout="total, sizes, prev, pager, next, jumper"
				  :page-sizes="[10, 20, 50, 100]"
				  :current-page="current"
				  :page-size="size"
				  :total="total">
				</el-pagination>

				<DeviceEcharts :deviceId="deviceId" v-if="DeviceInfo==1"/>
				<DeviceDoorRecord :deviceId="deviceId" v-else-if="DeviceInfo==2"/>
			</el-container>
		</el-container>

		<!--新增对话框-->
		<el-dialog
		  title="位置设备绑定"
		  :visible.sync="dialogVisible"
		  width="600px"
		  :before-close="handleClose"
		  :close-on-click-modal="false">

			<el-form :model="editForm" :rules="editFormRules" ref="editForm" label-width="100px" class="demo-editForm">

				<el-form-item label="安装位置：" prop="locationId" label-width="100px">
					<el-select v-model="editForm.locationId" placeholder="请选择安装位置">
						<el-option
						  :value="editForm.locationId"
						  :label="editForm.locationFullName"
						  style="width: 460px;height: 200px;overflow: auto;background-color: #fff;">
							<LocationTree @getTreeData="locationSelectNodeClick"/>
						</el-option>
					</el-select>
				</el-form-item>

				<el-form-item label="绑定设备：" prop="machineId" label-width="100px" required>
					<el-select v-model="editForm.machineId" placeholder="请选择设备">
						<el-option v-for="machineInfo in machineData"
								   :label="machineInfo.machineNum + '|' + machineInfo.shortName"
								   :value="machineInfo.id"
								   :key="machineInfo.id">
						</el-option>
					</el-select>
				</el-form-item>

				<el-form-item label="位置别名：" prop="shortName" label-width="100px" required>
					<el-input v-model="editForm.shortName" autocomplete="off"></el-input>
				</el-form-item>

				<!--				<el-form-item label="门号：" prop="doorNo" label-width="100px">-->
				<!--					<el-input-number v-model="editForm.doorNo" :min="1" :max="8" label="门数量"></el-input-number>-->
				<!--				</el-form-item>-->

				<!--				<el-form-item label="进/出标志：" prop="accessFlag" label-width="100px">-->
				<!--					<el-radio v-model="editForm.accessFlag" :label="1">进</el-radio>-->
				<!--  					<el-radio v-model="editForm.accessFlag" :label="0">出</el-radio>-->
				<!--				</el-form-item>-->

				<!--				<el-form-item label="密码开关：" prop="passwordFlag" label-width="100px">-->
				<!--					<el-radio v-model="editForm.passwordFlag" :label="1">开</el-radio>-->
				<!--  					<el-radio v-model="editForm.passwordFlag" :label="0">关</el-radio>-->
				<!--				</el-form-item>-->

			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="resetForm('editForm')">取 消</el-button>
				<el-button type="primary" @click="submitForm('editForm')">确 定</el-button>
			</div>
		</el-dialog>

		<!--新增对话框-->
		<el-dialog
		  :title="selectedMachineInfo"
		  :visible.sync="mediumDialogVisible"
		  width="1000px"
		  :before-close="handleMediumFormClose"
		  :close-on-click-modal="false">

			<el-form :model="mediumForm" ref="mediumForm" label-width="100px" class="demo-editForm">
				<el-container style="margin-top: -20px;">
					<el-main>
						<el-form :inline="true" style="margin-top: -20px;">
							<el-form-item>
								<el-input
								  v-model="newMediumVal"
								  placeholder="密码"
								  clearable
								>
								</el-input>
							</el-form-item>

							<el-form-item>
								<el-select v-model="newMediumType" placeholder="请选择类型">
									<!-- <el-option label="卡片" value="0"></el-option> -->
									<el-option label="单次密码" value="1"></el-option>
									<el-option label="固定密码" value="2"></el-option>
								</el-select>
							</el-form-item>

							<el-form-item>
								<el-date-picker
								  v-model="newMediumEndTime"
								  type="datetime"
								  value-format="yyyy-MM-dd HH:mm:ss"
								  placeholder="选择截止日期时间">
								</el-date-picker>
							</el-form-item>

							<el-form-item>
								<el-button type="primary" @click="bindMediumHandle">新增</el-button>
							</el-form-item>
						</el-form>
						<el-table
						  ref="mediumTable"
						  :data="mediumData"
						  tooltip-effect="dark"
						  style="width: 100%; height: 370px; margin-top: -20px;"
						  :row-style="{height: '0px'}"
						  :cell-style="{padding: '2px'}"
						  :header-cell-style="{background: '#E6F2FE', height:'8px',padding:'8px'}"
						  border
						  stripe>

							<el-table-column
							  type="selection"
							  width="55">
							</el-table-column>

							<el-table-column
							  prop="mediumVal"
							  label="密码"
							  width="100">
							</el-table-column>

							<el-table-column
							  prop="mediumFlag"
							  label="类型"
							  width="80">
								<template slot-scope="scope">
									<el-tag size="small" v-if="(scope.row.mediumFlag === 0)" type="success">卡片
									</el-tag>
									<el-tag size="small" v-else-if="(scope.row.mediumFlag === 1)" type="danger">
										单次密码
									</el-tag>
									<el-tag size="small" v-else-if="(scope.row.mediumFlag === 2)" type="success">
										固定密码
									</el-tag>
								</template>
							</el-table-column>

							<el-table-column
							  prop="statusFlag"
							  label="状态"
							  width="80">
								<template slot-scope="scope">
									<el-tag size="small" v-if="(scope.row.statusFlag === 1)" type="success">有效
									</el-tag>
									<el-tag size="small" v-else-if="(scope.row.statusFlag === 0)" type="danger">无效
									</el-tag>
								</template>
							</el-table-column>

							<el-table-column
							  prop="statusTime"
							  label="状态变动时间"
							  width="160"
							  show-overflow-tooltip>
							</el-table-column>

							<el-table-column
							  prop="regDate"
							  label="创建时间"
							  width="170">
							</el-table-column>

							<el-table-column
							  prop="endTime"
							  label="有效期"
							  width="160"
							  show-overflow-tooltip>
							</el-table-column>

							<el-table-column
							  prop="icon"
							  label="操作"
							  width="80">
								<template>
									<el-popconfirm title="确定要删除密码吗？"
												   @confirm="unBindMediumHandle(scope.row.id)">
										<el-button type="text" slot="reference">删除</el-button>
									</el-popconfirm>
								</template>
							</el-table-column>
						</el-table>

					</el-main>
				</el-container>
				<!-- <el-form-item>
					<el-button type="primary" @click="saveWhiteListHandle">保存</el-button>
					<el-button @click="resetForm('editForm')">取消</el-button>
				</el-form-item> -->
			</el-form>

			<div slot="footer" class="dialog-footer" style="margin-top: -50px;">
				<!-- <el-button @click="resetMediumForm('mediumForm')">取 消</el-button> -->
				<el-button type="primary" @click="resetMediumForm('mediumForm')">关 闭</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import LocationTree from "../base/LocationTree.vue";
import DeviceEcharts from "../components/Devicetemperaturehumidityecharts.vue";
import DeviceDoorRecord from "@/views/components/Devicedoorrecord.vue";
import *as echarts from 'echarts';


export default {
	name: "Builddevice",
	components: {LocationTree, DeviceEcharts, DeviceDoorRecord},
	data() {
		return {
			loading: true,

			listIconToggleValue: true,

			DeviceInfo: 0,

			searchForm: {
				isOnline: 0,
				isOpen: 0,
			},
			searchMachineForm: {},
			delBtlStatu: true,

			total: 0,
			size: 10,
			current: 1,

			dialogVisible: false,
			editForm: {},
			mediumDialogVisible: false,
			mediumForm: {},

			tableData: [],
			machineData: [],
			mediumData: [],

			selectedIdentityId: '',
			machineTypeList: [],
			multipleMachineSelection: [],

			editFormRules: {
				gatewayNO: [
					{required: true, message: '请输入网关编号', trigger: 'blur'}
				],
				gatewayType: [
					{required: true, message: '请选择设备类型', trigger: 'blur'}
				],
				locationId: [
					{required: true, message: '请选择安装位置', trigger: 'blur'}
				]
			},

			multipleSelection: [],

			permDialogVisible: false,
			permForm: {},
			defaultProps: {
				children: 'children',
				label: 'machineNum'
			},
			treeSelectLocationId: 0,
			selectedMachineInfo: '',
			bindMachineId: '',
			bindDoorNo: '',
			newMediumVal: '',
			newMediumType: '',
			newMediumEndTime: '',
			// permTreeData: []

			deviceId: undefined,

			echartsOption: {}
		}
	},
	computed: {
		tableHeight: function () {
			return screen.height > 900 ? 630 : 550
		}
	},
	created() {
		this.getLocationMachineList()
		this.getMachineList()

		// this.$axios.get('/iot/machine/list').then(res => {
		// 	this.permTreeData = res.data.data
		// })
	},
	mounted() {
		this.drawLine();
		this.getlocationtotal(1);
	},
	methods: {
		drawLine() {
			const myChart = echarts.init(document.getElementById("chart"));
			myChart.setOption(this.echartsOption);
		},
		toggleSelection(rows) {
			if (rows) {
				rows.forEach(row => {
					this.$refs.multipleTable.toggleRowSelection(row);
				});
			} else {
				this.$refs.multipleTable.clearSelection();
			}
		},
		handleSelectionChange(val) {
			console.log("勾选")
			console.log(val)
			this.multipleSelection = val;

			this.delBtlStatu = val.length == 0
		},
		handleSizeChange(val) {
			console.log(`每页 ${val} 条`);
			this.size = val
			this.getLocationMachineList()
		},
		handleCurrentChange(val) {
			console.log(`当前页: ${val}`);
			this.current = val
			this.getLocationMachineList()
		},
		handleMachineSelectionChange(val) {
			console.log("勾选")
			console.log(val)
			this.multipleMachineSelection = val;
		},
		resetForm(formName) {
			this.$refs[formName].resetFields();
			this.dialogVisible = false
			this.editForm = {}
		},
		resetMediumForm() {
			this.mediumDialogVisible = false
			this.mediumForm = {}
		},
		handleClose() {
			this.resetForm('editForm')
		},
		handleMediumFormClose() {
			this.resetForm('mediumForm')
		},
		locationSelectNodeClick(locationdata) {
			this.$set(this.editForm, "locationId", locationdata.id);
			this.$set(this.editForm, "locationFullName", locationdata.fullName);
			// console.log(deptdata);
		},
		locationTreeNodeClick(locationdata) {
			this.total = 0;
			this.size = 10;
			this.current = 1;
			this.treeSelectLocationId = locationdata.id;
			this.getLocationMachineList();
			this.getlocationtotal(locationdata.id);
		},

		getLocationMachineList() {
			this.loading = true;
			this.$axios.get("/iot/locationmachine/list", {
				params: {
					machineTypeIds: 22,
					locationId: this.treeSelectLocationId,
					current: this.current,
					size: this.size,
					...this.searchForm
				}
			}).then(res => {
				this.tableData = res.data.data.records
				this.size = res.data.data.size
				this.current = res.data.data.current
				this.total = res.data.data.total
				this.loading = false;
			})
		},
		getMachineList() {
			// this.$axios.get("/iot/locationmachine/machinelist", {
			// this.$axios.get("/iot/machine/list", {
			this.$axios.get("iot/machine/unbindlist", {
				params: {
					machineTypeIds: 22,
					// gatewayIds: "",
					// statusFlag: 1,
					// current: 0,
					// size: 10000
				}
			}).then(res => {
				this.machineData = res.data.data
			})
		},
		addHandle() {
			//新增
			// this.getMachineList();
			this.dialogVisible = true
		},
		submitForm(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					console.log(this.editForm);
					this.$axios.post('/iot/locationmachine/' + (this.editForm.id ? 'update' : 'save'), this.editForm)
					  .then(res => {

						  this.$message({
							  showClose: true,
							  message: '恭喜你，操作成功',
							  type: 'success',
							  onClose: () => {
								  this.getLocationMachineList()
							  }
						  });

						  this.dialogVisible = false
						  this.resetForm(formName)
					  })
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		editHandle(id) {
			this.$axios.get('/iot/locationmachine/info/' + id).then(res => {
				this.editForm = res.data.data

				this.dialogVisible = true
			})
		},
		delHandle(id) {
			const ids = [];
			if (id) {
				ids.push(id)
			} else {
				this.multipleSelection.forEach(row => {
					ids.push(row.id)
				})
			}
			console.log(ids)
			this.$axios.post("/iot/locationmachine/delete", ids).then(res => {
				this.$message({
					showClose: true,
					message: '恭喜你，操作成功',
					type: 'success',
					onClose: () => {
						this.getLocationMachineList()
					}
				});
			})
		},
		openHandle(id) {
			// this.$axios.post("/iot/locationmachine/open", id).then(res => {
			// 	this.$message({
			// 		showClose: true,
			// 		message: '恭喜你，操作成功',
			// 		type: 'success',
			// 		onClose: () => {
			// 			// this.getMachineList()
			// 		}
			// 	});
			// })
			this.$axios.post("/cabinet/openTask", id).then(res => {
				this.$message({
					showClose: true,
					message: '恭喜你，操作成功',
					type: 'success',
					onClose: () => {
						// this.getMachineList()
					}
				});
			})
		},
		mediumHandle(row) {
			if (row.passwordFlag === 0) {
				this.$message({
					showClose: true,
					message: '需要先打开【密码开关】才能设置密码',
					type: 'error'
				});
				return
			}
			this.bindMachineId = row.machineId;
			this.bindDoorNo = row.doorNo;
			this.selectedMachineInfo = row.locationFullName + "(" + row.machineNum + ") 密码设置";
			this.newMediumVal = ''
			this.getMediumList()
			this.mediumDialogVisible = true
		},
		getMediumList() {
			this.$axios.get("/iot/medium/list", {
				params: {
					machineId: this.bindMachineId,
					doorNo: this.bindDoorNo,
					current: 1,
					size: 100
				}
			}).then(res => {
				this.mediumData = res.data.data.records
			})
		},
		bindMediumHandle() {
			this.mediumForm.machineId = this.bindMachineId
			this.mediumForm.doorNo = this.bindDoorNo
			this.mediumForm.mediumFlag = this.newMediumType
			this.mediumForm.mediumVal = this.newMediumVal
			this.mediumForm.endTime = this.newMediumEndTime
			this.$axios.post('/iot/medium/bind', this.mediumForm)
			  .then(res => {
				  this.$message({
					  showClose: true,
					  message: '恭喜你，操作成功',
					  type: 'success',
					  onClose: () => {
						  this.getMediumList()
					  }
				  });
			  })
		},
		unBindMediumHandle(id) {
			this.$axios.post("/iot/medium/unbind", id).then(res => {
				this.$message({
					showClose: true,
					message: '恭喜你，操作成功',
					type: 'success',
					onClose: () => {
						this.getMediumList()
					}
				});
			})
		},
		humitureRecord(id) {
			this.DeviceInfo = 1;
			this.deviceId = id;
		},
		doorRecord(id) {
			this.DeviceInfo = 2;
			this.deviceId = id;
		},
		getlocationtotal(id) {
			this.$axios.get('/cabinet/locationtotal', {params: {locationId: id}}).then(res => {
				const {
					onlineCount,
					offlineCount,
					openCount,
					closeCount,
					temperatureOkCount,
					temperatureAlarmCount,
					humidityOkCount,
					humidityAlarmCount
				} = res.data.data;
				this.echartsOption = {
					color: ['#91cc75', '#fac858', '#fac858', '#91cc75', '#91cc75', '#fac858', '#91cc75', '#fac858'],
					tooltip: {
						trigger: 'item'
					},
					title: [
						// {
						// 	text: 'Pie label alignTo',
						// 	left: 'center'
						// },
						{
							subtext: '在线/离线',
							left: '12.5%',
							top: '70%',
							textAlign: 'center'
						},
						{
							subtext: '开/关',
							left: '37.5%',
							top: '70%',
							textAlign: 'center'
						},
						{
							subtext: '温度正常/异常',
							left: '62.5%',
							top: '70%',
							textAlign: 'center'
						},
						{
							subtext: '湿度正常异常',
							left: '87.5%',
							top: '70%',
							textAlign: 'center'
						}
					],
					series: [
						{
							type: 'pie',
							radius: '40%',
							center: ['50%', '35%'],
							data: [
								{
									name: '在线',
									value: onlineCount
								},
								{
									name: '离线',
									value: offlineCount
								},
							],
							label: {
								position: 'outer',
								alignTo: 'none',
								bleedMargin: 5
							},
							left: 0,
							right: '75%',
							top: 0,
							bottom: 0
						},
						{
							type: 'pie',
							radius: '40%',
							center: ['50%', '35%'],
							data: [
								{
									name: '开门',
									value: openCount
								},
								{
									name: '关门',
									value: closeCount
								},
							],
							label: {
								position: 'outer',
								alignTo: 'labelLine',
								bleedMargin: 5
							},
							left: '25%',
							right: '50%',
							top: 0,
							bottom: 0
						},
						{
							type: 'pie',
							radius: '40%',
							center: ['50%', '35%'],
							data: [
								{
									name: '温度正常',
									value: temperatureOkCount
								},
								{
									name: '温度异常',
									value: temperatureAlarmCount
								},
							],
							label: {
								position: 'outer',
								alignTo: 'edge',
								margin: 20
							},
							left: '50%',
							right: '25%',
							top: 0,
							bottom: 0
						},
						{
							type: 'pie',
							radius: '40%',
							center: ['50%', '35%'],
							data: [
								{
									name: '湿度正常',
									value: humidityOkCount
								},
								{
									name: '湿度异常',
									value: humidityAlarmCount
								},
							],
							label: {
								position: 'outer',
								alignTo: 'edge',
								margin: 20
							},
							left: '75%',
							right: 0,
							top: 0,
							bottom: 0
						}
					]
				}
				this.drawLine();
			})
		}
	}
}
</script>

<style scoped>

.el-pagination {
	float: right;
	margin-top: 22px;
}

.el-select {
	width: 96%;
}

.btn {
	display: flex;
	justify-content: right;

	/* .el-button:first-child {
		margin-right: 30px;
	} */
}

.icon-container {
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	justify-content: center;
}

.icon-content {
	margin: 15px;
	min-width: 300px;
	/*height: 200px;*/
	text-align: center;

	/*background-color: #3A92F4;*/
	/*color: white;*/
}

.icon-content i {
	font-size: 32px;
}

.icon-success, .icon-error {
	margin: auto;
	width: 15px;
	height: 15px;
	border-radius: 50%;
	transform: translate(-50%, -50%);
	top: 50%;
	left: 50%;
	position: absolute;
}

.icon-success {
	background-color: #6fde4a;
}

.icon-error {
	background-color: #f13434;
}

.el-form-item {
	margin-bottom: 0;
}
</style>